module.exports = __webpack_public_path__ + "files/bb42ed577104209d5a3d95fb06db51b3.png";